module.exports = __webpack_public_path__ + "static/media/errorIcon.0005c4e3.svg";